<template>
  <div class="gacha-container">
    <div class="top-bar">
      <div class="left-empty">
        <el-button type="warning" @click="$router.back()" size="mini" plain>
          <i class="el-icon-back"></i> 返回
        </el-button>
      </div>
      <h2 class="title">我的收藏</h2>
      <div class="right-empty"></div>
    </div>

    <div v-if="loading" class="loading-mask">
      <div class="loading-box">Loading, please wait...</div>
    </div>
    <div v-else>
      <div class="filter-row">
        <div class="filter-group">
          <el-button
              class="glow-btn"
              size="small"
              :type="titleId === null ? 'warning' : 'default'"
              @click="titleId=null;getCardsUser()">
            全部系列
          </el-button>
          <el-button
              class="glow-btn"
              v-for="item in titles"
              :key="item.id"
              :type="titleId === item.id ? 'warning' : 'default'"
              @click="goGetMyCards(item.id)"
              size="small"
          >
            {{ item.name }}
          </el-button>
        </div>

        <div class="filter-group">
          <el-button
              class="glow-btn"
              size="small"
              :type="propertyId === null ? 'warning' : 'default'"
              @click="propertyId=null;getCardsUser()">
            全部属性
          </el-button>
          <el-button
              class="glow-btn"
              v-for="item in propertys"
              :key="item.id"
              :type="propertyId === item.id ? 'warning' : 'default'"
              @click="goGetMyCardsByProperty(item.id)"
              size="small"
          >
            {{ item.name }}
          </el-button>
        </div>
      </div>

      <div class="content-box">
        <div class="card-grid">
          <div
              class="card-item"
              @click="showCardImage(index)"
              :class="{ active: activeIndex === index }"
              v-for="(item, index) in cardList"
              :key="item.id"
          >
            <img v-if="item.userCardCount>0" class="card-img" :src="item.image" alt="" />
            <img v-if="item.userCardCount==0" class="card-img" :src="require('@/assets/images/noka.png')" alt="" />
            <div class="card-overlay" />
            <div class="card-info">
              <div class="card-name">{{ item.cardName }}</div>
              <div class="card-tags">
                <span class="tag" :class="`tag-${item.propertyId}`">{{ item.titleName }}</span>
                <span class="tag" :class="`tag-${item.propertyId}`">{{ item.propertyName }}</span>
                <span class="tag" :class="`tag-${item.propertyId}`">持有：{{ item.userCardCount }} 張</span>
              </div>
            </div>
          </div>
        </div>
        <!-- 分页控件 -->
        <div class="pagination-container" v-if="total > 0">
          <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="listQ._page2"
              :page-sizes="[12, 24, 36, 48]"
              :page-size="listQ._limit"
              layout="prev, pager, next, jumper, ->, total"
              :total="total"
          />
        </div>

      </div>
    </div>

    <div class="modal-mask" v-show="showCardModal" @click.self="showCardModal=false">
      <div class="modal-content">
        <div class="modal-close-x" @click="showCardModal=false">×</div>
        <img v-if="userCardCount>0" class="modal-image" :src="cardPreviewImage" alt="" />
        <img v-if="userCardCount==0" class="modal-image" :src="require('@/assets/images/noka.png')" alt="" />

        <div class="modal-name">{{ cardPreviewName }}</div>
        <div class="modal-attrs">
          <span class="tag" :class="`tag-${cardPreviewPropertyId}`">{{ cardPreviewTitleName }}</span>
          <span class="tag" :class="`tag-${cardPreviewPropertyId}`">{{ cardPreviewPropertyName }}</span>
          <span class="tag" :class="`tag-${cardPreviewPropertyId}`">持有：{{ userCardCount }} 張</span>
        </div>
        <div class="modal-content-text">{{ cardPreviewContent }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCardsUser, indexTitle, indexProperty } from "@/api/cards";

export default {
  data() {
    return {
      loading: true,
      activeIndex: -1,
      showCardModal: false,
      cardPreviewImage: "",
      cardPreviewName: "",
      cardPreviewPropertyName: "",
      userCardCount: 0,
      cardPreviewPropertyId: "",
      cardPreviewContent: "",
      cardPreviewTitleName: "",
      cardList: [],
      titles: [],
      propertys: [],
      total: 0,
      titleId: null,
      propertyId: null,
      listQ: {
        _page2: 1,    // 当前页码
        _limit: 12    // 每页数量
      },
    };
  },
  created() {
    this.indexTitle();
    this.indexProperty();
    this.getCardsUser();
  },
  methods: {
    // 切换系列 → 重置到第1页
    goGetMyCards(id) {
      this.titleId = id;
      this.listQ._page2 = 1;
      this.getCardsUser();
    },
    // 切换属性 → 重置到第1页
    goGetMyCardsByProperty(id) {
      this.propertyId = id;
      this.listQ._page2 = 1;
      this.getCardsUser();
    },
    indexTitle() {
      indexTitle().then((v) => {
        this.titles = v.data;
      });
    },
    indexProperty() {
      indexProperty().then((v) => {
        this.propertys = v.data;
      });
    },
    // 获取我的卡片（带分页）
    getCardsUser() {
      let form = {
        titleId: this.titleId,
        propertyId: this.propertyId,
        _page: this.listQ._page2 - 1,  // 后端从0开始
        _limit: this.listQ._limit,
      };
      getCardsUser(form).then((v) => {
        this.cardList = v.data;
        this.total = Number(v.headers["x-total-count"] || 0);
        this.loading = false;
      });
    },
    // 每页条数改变
    handleSizeChange(val) {
      this.listQ._limit = val;
      this.getCardsUser();
    },
    // 当前页码改变
    handleCurrentChange(val) {
      this.listQ._page2 = val;
      this.getCardsUser();
    },
    showCardImage(index) {
      this.activeIndex = index;
      const item = this.cardList[index];
      this.cardPreviewName = item.cardName;
      this.cardPreviewImage = item.image;
      this.cardPreviewPropertyName = item.propertyName;
      this.userCardCount = item.userCardCount;
      this.cardPreviewPropertyId = item.propertyId;
      this.cardPreviewContent = item.content;
      this.cardPreviewTitleName = item.titleName;
      this.showCardModal = true;
    },
  },
};
</script>

<style scoped>
:root {
  background: #0d0d13;
  min-height: 100vh;
}

.gacha-container {
  max-width: 860px;
  margin: 0 auto;
  padding: 40px 20px;
}

.loading-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}
.loading-box {
  background: #fff;
  padding: 25px 40px;
  border-radius: 12px;
  font-size: 16px;
  color: #333;
}

.top-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 20px;
  position: relative;
  z-index: 1999 !important;
}
.left-empty {
  flex: 1;
  text-align: left;
}
.right-empty {
  flex: 1;
  text-align: right;
}
.title {
  flex: 2;
  text-align: center;
  color: #fff;
  text-shadow: 0 0 10px rgba(255, 215, 0, 0.7);
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-size: 3rem;
  font-weight: 700;
  font-family: "GenSenRoundedTW", "Helvetica", "Arial";
  text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.8);
}

.filter-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  margin-bottom: 30px;
  padding: 16px 20px;
  background: rgba(255, 255, 255, 1);
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  backdrop-filter: blur(10px);
}
.filter-group {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

:deep(.glow-btn) {
  position: relative;
  border-radius: 10px !important;
  padding: 6px 14px !important;
  font-weight: 600 !important;
  border: none !important;
  color: #fff !important;
  background: rgba(255, 255, 255, 0.06) !important;
  transition: all 0.3s ease !important;
  overflow: hidden;
}
:deep(.glow-btn:hover) {
  transform: translateY(-2px) !important;
  background: rgba(136, 96, 255, 0.25) !important;
  box-shadow: 0 0 12px rgba(136, 96, 255, 0.4) !important;
}
:deep(.glow-btn.is-active) {
  background: linear-gradient(90deg, #7c4dff, #b26eff) !important;
  box-shadow: 0 0 18px rgba(124, 77, 255, 0.6) !important;
  color: #fff !important;
  font-weight: bold !important;
}
:deep(.glow-btn:active) {
  transform: translateY(0px) !important;
}

.card-grid {
  display: grid;
  grid-template-columns: repeat(4, 260px);
  grid-auto-rows: 365px;
  gap: 20px;
  justify-content: center;
}
.card-item {
  position: relative;
  border-radius: 20px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
  box-shadow: 0 8px 24px rgba(0,0,0,0.6);
}
.card-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.card-overlay {
  position: absolute;
  inset: 0;
  z-index: 1;
}
.card-info {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 18px 14px;
  z-index: 2;
  text-align: left;
}
.card-name {
  font-size: 18px;
  font-weight: bold;
  color: #fff;
  margin-bottom: 8px;
  text-shadow: 0 2px 8px #444;
}
.card-tags {
  display: flex;
  gap: 6px;
}

/* 标签样式（卡片 + 弹窗共用） */
.tag {
  font-size: 12px;
  padding: 4px 10px;
  border-radius: 999px;
  font-weight: bold;
  color: #fff;
  background-size: 200% 200%;
  animation: tagGlow 3s linear infinite;
}
@keyframes tagGlow {
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
}
.tag-1 { background: #999; }
.tag-2 { background: #9370db; }
.tag-3 { background: #ffd700; }
.tag-4 { background: rgb(246 134 44); }
.tag-5 { background: #7cb8ff; }
/* 卡片边框稀有度 */
.rarity-1 { border: 4px solid #999; }
.rarity-2 { border: 4px solid #6fb7ff; }
.rarity-3 { border: 4px solid #4d9dff; }
.rarity-4 { border: 4px solid #9370db; }
.rarity-5 { border: 4px solid #ffd700; }

.card-item:hover {
  transform: translateY(-8px) scale(1.02);
  box-shadow: 0 16px 40px rgba(0,0,0,0.6);
}

/* 分页样式 */
.pagination-container {
  display: flex;
  justify-content: center;
  margin-top: 40px;
}
:deep(.el-pagination) {
  --el-pagination-bg-color: transparent;
  --el-pagination-text-color: #fff;
  --el-pagination-hover-text-color: #ffd700;
  --el-pagination-active-text-color: #ffd700;
}
:deep(.el-pagination button) {
  color: #fff;
  background: rgba(255,255,255,0.06);
  border-color: rgba(255,255,255,0.1);
}
:deep(.el-pagination button:hover) {
  color: #ffd700;
  background: rgba(255,215,0,0.1);
}
:deep(.el-pagination .el-pager li) {
  color: #fff;
  background: rgba(255,255,255,0.06);
  border-color: rgba(255,255,255,0.1);
}
:deep(.el-pagination .el-pager li.active) {
  color: #fff;
  background: #ffd700;
  border-color: #ffd700;
}
:deep(.el-pagination .el-pager li:hover:not(.active)) {
  color: #ffd700;
  background: rgba(255,215,0,0.1);
}

/* 弹窗：无边框 + 透明 + 右上角关闭 */
.modal-mask {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  background: rgba(0, 0, 0, 0.85);
}
.modal-content {
  position: relative;
  background: transparent;
  width: 90%;
  max-width: 360px;
  border-radius: 24px;
  padding: 0;
  border: none;
  box-shadow: none;
  animation: modalIn 0.4s ease;
}
@keyframes modalIn {
  from { transform: scale(0.9); opacity: 0; }
  to { transform: scale(1); opacity: 1; }
}
.modal-close-x {
  position: absolute;
  right: -10px;
  top: -10px;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: rgba(0,0,0,0.5);
  color: #fff;
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10;
}
.modal-image {
  width: 100%;
  border-radius: 18px;
  margin-bottom: 20px;
}
.modal-name {
  font-size: 28px;
  font-weight: bold;
  color: #fff;
  margin-bottom: 12px;
  text-align: center;
}
.modal-attrs {
  display: flex;
  justify-content: center;
  gap: 8px;
  margin-bottom: 16px;
}
.modal-content-text {
  font-size: 15px;
  color: #fff;
  line-height: 1.6;
  margin-bottom: 28px;
  text-align: center;
}
</style>